import SettingTypes from '@/utils/setting-types'

export default {
  name: 'float-navbar',
  label: {
    title: '浮动导航栏',
    icon: require('@/assets/icon-component-label_FloatNavbar.svg'),
    limit: 1
  },
  tip: '注意:不可与浮动搜索栏一起使用,会有相互遮盖问题',
  decor_type: 'admin',
  sort: 1003,
  data: {
    show_logo: true,
    navList: [],
    show_right_btn: true,
    right_btn_text: '查看更多',
    right_btn_link: null,
    right_btn_bg_color: '#336fff'
  },
  settings: {
    show_logo: {
      type: SettingTypes.boolean,
      label: '显示LOGO',
      props: {
        activeText: '显示',
        inactiveText: '不显示'
      }
    },
    navList: {
      type: SettingTypes.custom,
      label: '导航列表',
      component_name: 'FloatNavbarList'
    },
    show_right_btn: {
      type: SettingTypes.boolean,
      label: '显示右侧按钮',
      props: {
        activeText: '显示',
        inactiveText: '不显示'
      }
    },
    right_btn_text: {
      type: SettingTypes.input,
      label: '按钮文字',
      show: data => !!data.show_right_btn
    },
    right_btn_link: {
      type: SettingTypes.link,
      label: '按钮链接',
      show: data => !!data.show_right_btn
    },
    right_btn_bg_color: {
      type: SettingTypes.color_picker,
      label: '按钮颜色',
      default: '#336fff',
      show: data => !!data.show_right_btn
    }
  }
}
